export default {
	namespaced: true,
	state: {
		items: [],
		sortBy: 0,
		nonce: null,
	},
	getters: {
		items: state => state.items,
		sortBy: state => state.sortBy,
		isLoading: state => Boolean(state.nonce),
	},
	mutations: {
		SORT_BY(state, value){
			if(typeof value !== 'number') console.warn("library sort must be number")
			else state.sortBy = value
		}
	},
	actions: {
		api: ({dispatch}, [name, ...input]) => dispatch('api/genericHandler', ['media/library/'+name, ...input], {root:true}),
		changeSort({dispatch, commit}, sort){
			commit('SORT_BY', sort)
			dispatch('load')
		},
		async load({state, dispatch}){
			state.items = []
			let nonce = state.nonce = {}

			let res = await dispatch('api', ['get', state.sortBy, () => dispatch('popups/show/error/custom', 'loading the library', {root: true})])

			if(nonce !== state.nonce) return;

			if(res?.success) state.items = res.success
			state.nonce = null
		},
		async delete({dispatch}, id){
			let res = await dispatch('api', ['adminDelete', id, () => dispatch('popups/show/error/deleting', 'This link', {root: true})])

			if(res?.success) {
				dispatch('popups/show/success/deleting', 'Link', {root:true})
				dispatch('load')
			}
		},
		async deleteAll({dispatch, state}){
			let res = await dispatch('api', ['adminDeleteAll', null, () => dispatch('popups/show/error/deleting', 'Library', {root: true})])

			if(res?.success){
				dispatch('popups/show/success/deleting', 'Library', {root:true})
				state.items = []
			}
		}
	},
}
